import { TransportManagementSearchCriteria } from '../models';
import { ListViewMode } from '../../constants/list-view-mode.constant';
import { MatDialogRef } from '@angular/material/dialog';
import { ExportDialogComponent } from '../../../../../ui-kit';

export class TransportManagementExportToFileStart {
  public static readonly type = '[TransportManagementExportToFile] Start';

  constructor(
    public payload: {
      reportName: string;
      viewMode: ListViewMode;
      filter: Partial<TransportManagementSearchCriteria>;
      dialogRef: MatDialogRef<ExportDialogComponent>;
      navigationNeeded: boolean;
    },
  ) {}
}
